import { useContext } from 'react';
import { TokenContext } from '../context/token-context';

/** Returns TokenGate's bootstrap token (route gate), or null if unauthenticated. */
export function useToken(): string | null {
  return useContext(TokenContext);
}
